import { RootState } from "../../store";

export const isAppReady = (state: RootState) => state.common.isReady;
